<template>
  <v-form ref="columnForm">
    <v-layout row wrap>
      <v-flex xs12>
        <hot-table
          ref="hotTable"
          id="hot-table"
          :settings="tableSettings"
        ></hot-table>
      </v-flex>
    </v-layout>
    <v-layout align-space-between justify-space-between row wrap pt-3>
      <v-flex xs3 md2 offset-md1 pr-3>
        <table-column-select
          v-model="columnMaterial"
          v-validate="'required|min_value:1'"
          label="Material No. column"
          :number-of-columns="numberOfColumns"
        ></table-column-select>
      </v-flex>
      <v-flex xs3 md2 pr-3>
        <table-column-select
          v-model="columnQuantity"
          v-validate="'required|min_value:1'"
          label="Quantity column"
          :number-of-columns="numberOfColumns"
        ></table-column-select>
      </v-flex>
      <v-flex xs6 md7 pt-2>
        <v-btn color="primary mx-0" @click="onClickContinue">Validate</v-btn>
        <v-btn @click="onClear" flat>Clear</v-btn>
      </v-flex>
    </v-layout>
    <v-alert
      type="error"
      :value="errors.any()"
      v-for="(error, index) in errors.all()"
      :key="index"
    >
      {{ error }}
    </v-alert>
  </v-form>
</template>

<script>
import HotTable from "@handsontable/vue";
import "handsontable/dist/handsontable.css";
import TableColumnSelect from "@/components/TableColumnSelect.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    HotTable,
    TableColumnSelect
  },
  data() {
    return {
      tableSettings: {
        colHeaders: true,
        colWidths: [85, 85, 85, 85, 80, 80, 80, 80],
        contextMenu: true,
        data: null,
        manualColumnResize: true,
        minSpareRows: 1,
        rowHeaders: true,
        afterChange: () => {
          if (this.hotRef) {
            const tableData = this.hotRef.getSourceData();
            this.$store.dispatch("changeTableData", tableData);
          }
        }
      },
      hotRef: null
    };
  },
  computed: {
    numberOfColumns() {
      return this.$store.state.table_to_basket.numberOfColumns;
    },
    columnMaterial: {
      get() {
        return this.$store.state.table_to_basket.columnMaterial;
      },
      set(value) {
        this.$store.commit("setColumnMaterial", value);
      }
    },
    columnQuantity: {
      get() {
        return this.$store.state.table_to_basket.columnQuantity;
      },
      set(value) {
        this.$store.commit("setColumnQuantity", value);
      }
    }
  },
  methods: {
    onClickContinue() {
      this.$validator.validate().then(valid => {
        if (!valid) {
          return;
        }
        this.$emit("continue");
      });
    },
    onClear() {
      this.errors.clear();
      this.hotRef.clear();
      this.$refs.columnForm.reset();
    }
  },
  mounted() {
    this.hotRef = this.$refs.hotTable.hotInstance;
    this.tableSettings.data = this.$store.getters["getTableData"];
  }
};
</script>
